import script from "./DocumentTemplateForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentTemplateForm.vue?vue&type=script&lang=ts&setup=true"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./DocumentTemplateForm.vue?vue&type=style&index=1&id=62acd7dd&lang=css"

const __exports__ = script;

export default __exports__